import React, { useState } from "react";
import SalesList from "./components/SalesList";
import SalesCreate from "./components/SalesCreate";
import { BaseLayout } from "../../layouts";
import { useTranslation } from "react-i18next";
import * as routes from "../../app/routes";
import { Add } from "@mui/icons-material";

function Sales() {
  const [translate] = useTranslation();
  const [createOp, setCreateOp] = useState(false);

  const handleClick = () => {
    setCreateOp(true);
  };

  const handleDialogClosing = () => {
    setCreateOp(false);
  };

  return (
    <BaseLayout
      moduleName={translate("sales", "Pardavimai")}
      modulePath={routes.ROUTE_SALES.path}
      isDocumentList
      button={{
        btnIcon: <Add />,
        btnText: translate("new", "Nauja"),
        btnOnClick: handleClick,
      }}
    >
      {createOp && (
        <SalesCreate open={createOp} onClose={handleDialogClosing} />
      )}
      <SalesList />
    </BaseLayout>
  );
}

export default Sales;
